var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "form-row row-with-label" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("login.password")))]),
          _vm._v(" "),
          _c("InputPassword", {
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "UiCompletionCard",
        [
          _c(
            "UiCompletionList",
            [
              _c(
                "UiCompletionLine",
                {
                  attrs: {
                    is_completed: _vm.pwdHasValidLength,
                    is_required: true,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("login.password_rules.length")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "UiCompletionLine",
                {
                  attrs: {
                    is_completed: _vm.pwdHasLowerChar,
                    is_required: true,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("login.password_rules.lowercase")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "UiCompletionLine",
                {
                  attrs: {
                    is_completed: _vm.pwdHasUpperChar,
                    is_required: true,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("login.password_rules.uppercase")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "UiCompletionLine",
                {
                  attrs: { is_completed: _vm.pwdHasNumber, is_required: true },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("login.password_rules.number")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "UiCompletionLine",
                {
                  attrs: {
                    is_completed: _vm.pwdHasSpecialChar,
                    is_required: true,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("login.password_rules.special_char")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-row row-with-label mt-3" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("login.passwordConfirm")))]),
          _vm._v(" "),
          _c("InputPassword", {
            attrs: { id: "passwordConfirm", name: "passwordConfirm" },
            model: {
              value: _vm.passwordConfirm,
              callback: function ($$v) {
                _vm.passwordConfirm = $$v
              },
              expression: "passwordConfirm",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "UiCompletionList",
        [
          _c(
            "UiCompletionLine",
            { attrs: { is_completed: _vm.pwdsAreEquals, is_required: true } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("login.password_rules.identical")) +
                  "\n      "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }